<template>
  <DashboardPage>
    <ProductForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import ProductForm from './components/ProductForm.vue';

const route = useRoute()

</script>